import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadContactActions'
import * as api from '../../api/lead/contacts'

import { fetchLeadDetails } from '../leadDetails'

function* leadContactsRefresh(action) {
  try {
    const payload = yield call(api.getLeadContacts, action.leadId)
    yield put({ type: constants.LEAD_CONTACTS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTACTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchLeadContacts() {
  yield takeLatest(constants.LEAD_CONTACTS_REFRESH.ACTION, leadContactsRefresh)
}

function* getAllLeadContacts(action) {
  try {
    const payload = yield call(api.getAllLeadContacts)
    yield put({ type: constants.GET_ALL_LEAD_CONTACTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_LEAD_CONTACTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllContacts() {
  yield takeLatest(constants.GET_ALL_LEAD_CONTACTS.ACTION, getAllLeadContacts)
}

function* sagaCreateJobContact(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createContact, payload)
    yield put({ type: constants.CREATE_CONTACT.SUCCESS, payload })
    yield call(getAllLeadContacts)
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobContact() {
  yield takeLatest(constants.CREATE_CONTACT.ACTION, sagaCreateJobContact)
}

function* sagaAddJobContact(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.addLeadContact, payload)
    yield put({ type: constants.ADD_LEAD_CONTACT.SUCCESS, payload })
    yield call(leadContactsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_LEAD_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddJobContact() {
  yield takeLatest(constants.ADD_LEAD_CONTACT.ACTION, sagaAddJobContact)
}

function* sagaRemoveJobContact(action) {
  try {
    const payload = {
      contact_id: action.contactId
    }
    yield call(api.removeLeadContact, payload)
    yield put({ type: constants.REMOVE_LEAD_CONTACT.SUCCESS, payload })
    yield call(leadContactsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.REMOVE_LEAD_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchRemoveJobContact() {
  yield takeLatest(constants.REMOVE_LEAD_CONTACT.ACTION, sagaRemoveJobContact)
}

function* sagaUpdateJobContact(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      attachment_id: action.attachmentId,
      description: action.description,
      updated_by_id: action.userId,
      user_id: 1,
      files: action.files
    }
    yield call(api.updateLeadContact, payload)
    yield put({ type: constants.LEAD_CONTACT_UPDATE.SUCCESS, payload })
    yield call(leadContactsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTACT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobContact() {
  yield takeLatest(constants.LEAD_CONTACT_UPDATE.ACTION, sagaUpdateJobContact)
}

function* sagaDeleteJobContact(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteLeadContact, payload)
    yield put({ type: constants.LEAD_CONTACT_DELETE.SUCCESS, payload })
    yield call(leadContactsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CONTACT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobContact() {
  yield takeLatest(constants.LEAD_CONTACT_DELETE.ACTION, sagaDeleteJobContact)
}

function* sagaUpdateLeadPrimaryContact(action) {
  try {
    const payload = {
      leadId: action.leadId,
      contactId: action.contactId
    }
    yield call(api.updateLeadPrimaryContact, payload)
    yield put({ type: constants.UPDATE_LEAD_PRIMARY_CONTACT.SUCCESS, payload })
    yield call(leadContactsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_LEAD_PRIMARY_CONTACT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadPrimaryContact() {
  yield takeLatest(constants.UPDATE_LEAD_PRIMARY_CONTACT.ACTION, sagaUpdateLeadPrimaryContact)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadContacts),
    fork(watchGetAllContacts),
    fork(watchAddJobContact),
    fork(watchRemoveJobContact),

    fork(watchCreateJobContact),
    fork(watchUpdateJobContact),
    fork(watchDeleteJobContact),

    fork(watchUpdateLeadPrimaryContact)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadContactSaga.js